const dateFns = require('date-fns');
const dateFnsTz = require('date-fns-tz');
const store = require('../store');

const DEFAULT_TIMEZONE = 'America/Phoenix';

const getCompanyTimeZone = () => {
    return store.default.getters['auth/company']?.timeZone ?? DEFAULT_TIMEZONE;
}

const toDate = (date) => (date instanceof Date) ? date : new Date(date);

function formatDate(date, timeZone) {
    const tz = timeZone ?? getCompanyTimeZone();
    const tzDate = dateFnsTz.utcToZonedTime(toDate(date), tz);
    return dateFnsTz.formatInTimeZone(tzDate, tz, 'M/d/yyyy');
}

function formatTime(date, timeZone) {
    const tz = timeZone ?? getCompanyTimeZone();
    const tzDate = dateFnsTz.utcToZonedTime(toDate(date), tz);
    return dateFnsTz.formatInTimeZone(tzDate, tz, 'h:mm a');
}

function formatDateTime(date, timeZone, format = 'MMM d, h:mm a') {
    const tz = timeZone ?? getCompanyTimeZone();
    const tzDate = dateFnsTz.utcToZonedTime(toDate(date), tz);
    return dateFnsTz.formatInTimeZone(tzDate, tz, format);
}

function formatDateDistance(date, timeZone) {
    const tz = timeZone ?? getCompanyTimeZone();
    const tzDate = dateFnsTz.utcToZonedTime(toDate(date), tz);
    const tzNow = dateFnsTz.utcToZonedTime(new Date(), tz);
    return dateFns.formatDistance(tzDate, tzNow, { addSuffix: true });
}

function formatCurrency(number) {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    return formatter.format(number);
}

function roundToNearestDecimalPlace(value, decimalPlace = 2) {
    const multiplier = Math.pow(10, decimalPlace);
    return Math.round(value * multiplier) / multiplier;
}

function formatTons(number) {
    return number / 2000;
}

// TODO: Remove this function when the API is updated to return full URLs
function getApiImgPath(fileName) {
    return `https://user-content.dumptek.com/photos/${fileName}`;
}

function humanizeTime(hours) {
    const totalMinutes = Math.round(hours * 60);
    const days = Math.floor(totalMinutes / 1440); // 60 * 24
    const hrs = Math.floor((totalMinutes % 1440) / 60);
    const mins = totalMinutes % 60;
  
    const duration = {
      days,
      hours: hrs,
      minutes: mins,
    };
  
    const formattedDuration = dateFns.formatDuration(duration, {
      format: ['days', 'hours', 'minutes'],
      zero: false,
    });

    if(duration.days === 0 && duration.hours === 0 && duration.minutes === 0) {
        return '0m';
    }
  
    return formattedDuration
      .replace(/(\d+)\sdays?/, '$1d')
      .replace(/(\d+)\shours?/, '$1h')
      .replace(/(\d+)\sminutes?/, '$1m');
}  

function integerToCurrency(value) {
    return value / 100;
}
  

module.exports = {
    formatDate,
    formatTime,
    formatDateTime,
    formatDateDistance,
    roundToNearestDecimalPlace,
    formatCurrency,
    formatTons,
    getApiImgPath,
    humanizeTime,
    integerToCurrency,
};
